import { usePeriod } from "backend/model/usePeriod";
import getValues from "backend/values";
import { resultSort } from "init/sort";
import { useAppContext } from "qpr-base/context/AppCtxProvider";

import isDraftFilterAtLocation from "qpr-base/attributes/drafts/disabledPages";
import { useQuery } from "react-query";
import usePeriodLevels from "../model/usePeriodLevels";

const useElements = (id?: string[]) => {
  const ctx = useAppContext();
  const periods = usePeriod();
  const { data: periodLevels } = usePeriodLevels();
  return useQuery(
    `data-element-${JSON.stringify(id)}-${JSON.stringify(
      ctx.period
    )}-${isDraftFilterAtLocation()}`,
    () => {
      return getValues(
        id || ctx.elementId || "",
        periods.filter((n) => n.name === ctx.period),
        true,
        periodLevels!
      ).then((list) => {
        return resultSort(list);
      });
    },
    {
      enabled: !!periodLevels && !!id && periods?.length > 0,
      cacheTime: 10 * (60 * 1000),
      staleTime: 10 * (60 * 1000),
    }
  );
};

export default useElements;
